import React from 'react';
import { translate } from 'react-polyglot';

import ButtonGroup from '../ButtonGroup';
import Button from '../Button';
import Modal from '../Modal';

const SyncTranslationModal = ({
  t,
  onConfirm,
  onClose,
  viewport,
  isRtl
}) => {

  const parentClassName = 'pb-inner-modal';

  const footer = (
    <ButtonGroup mergeTop mergeBottom={!viewport.large} mergeSides>
      <Button label={t('global.yes')} variant="primary" onClick={() => { onConfirm(); onClose() }} />
      <Button label={t('global.cancel')} onClick={onClose} />
    </ButtonGroup>
  );

  return (
    <Modal footer={footer} onClose={onClose} parentClassName={parentClassName} isRtl={isRtl}>
      <h2 className={`${parentClassName}__title`}>{t('SyncTranslationModal.title')}</h2>
      <p>{t('SyncTranslationModal.content')}</p>
    </Modal>
  );
};

export default translate()(SyncTranslationModal);



// WEBPACK FOOTER //
// ./src/components/OfflineTranslate/SyncTranslationModal.jsx